// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { Mypage as MypageScreen } from 'components/organisms/Mypage';

import { useTranslation } from 'react-i18next';

const Mypage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PrimaryTemplate h1={t('my_page.title')} headerSticky={true}>
        <MypageScreen />
      </PrimaryTemplate>
    </div>
  );
};

export default Mypage;
